import {SignalR} from "../../config";

const authenticationSettingsChanged = 'AuthenticationSettingsChanged';
const accountSelfCreationSettingsChanged = 'AccountSelfCreationSettingsChanged';

class ConfigurationHub extends SignalR {

    private static instance: ConfigurationHub;

    private constructor() {
        super("configuration");
    }

    public static getInstance(): ConfigurationHub {
        
        if (!ConfigurationHub.instance){

            ConfigurationHub.instance = new ConfigurationHub();

            // ConfigurationHub.instance.start();

        }

        return ConfigurationHub.instance;
    }

    public OnAuthenticationSettingsChanged(callback: (authenticationSettings: any) => void) {
        console.log('OnAuthenticationSettingsChanged');
        this.on(authenticationSettingsChanged, callback);
    }
    public OnAccountSelfCreationSettingsChanged(callback: (accountSelfCreationSettings: any) => void) {
        console.log('OnAccountSelfCreationSettingsChanged');
        this.on(accountSelfCreationSettingsChanged, callback);
    }

}

const configurationHub = ConfigurationHub.getInstance();

export { configurationHub };